import * as Yup from "yup";

import {TEXT_DIRECTION, textDirectionLabels,} from "@/constant/Languages/text-direction";

import {STATUS} from "@/constant/statusConstants";

const textDirectionLabelsMap = textDirectionLabels();
const tdLabelLtr = textDirectionLabelsMap[TEXT_DIRECTION.LEFT_TO_RIGHT];
const tdLabelRtl = textDirectionLabelsMap[TEXT_DIRECTION.RIGHT_TO_LEFT];

const getLanguageSchema = (isEdit = false) =>
  Yup.object().shape({
    title: Yup.string()
      .label("Language")
      .required()
      .max(255),
    label: Yup.string()
      .label("Label")
      .required()
      .max(255),
    slug: Yup.string()
      .label("Slug")
      .required()
      .max(255),
    code: Yup.string()
      .label("2-Letter Code")
      .when([], {
        is: () => !isEdit,
        then: (schema) => schema.required().max(8),
        otherwise: (schema) => schema.nullable()
      }),
    code_alpha_3: Yup.string()
      .label("3-Letter Code")
      .when([], {
        is: () => !isEdit,
        then: (schema) => schema.required().max(8),
        otherwise: (schema) => schema.nullable()
      }),
    rtl: Yup
      .number()
      .label("Text Direction")
      .required()
      .oneOf(
        Object.values(TEXT_DIRECTION),
        `Text Direction must be one of the following values: ${tdLabelLtr}, ${tdLabelRtl}`
      ),
    status: Yup
      .string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
    icon: Yup.mixed()
      .label("Icon")
      .when([], {
        is: () => isEdit,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required(),
      }),
  });

export default getLanguageSchema;
